import { ActionReducerMapBuilder } from '@reduxjs/toolkit'

import { getTikTokFollowWelcomeMessageState } from 'apps/tiktokFollowWelcome/adapter'
import { TikTokFollowWelcomeState } from 'apps/tiktokFollowWelcome/interfaces'
import { NAMESPACE } from 'apps/tiktokFollowWelcome/store/constants'
import { tiktokApi } from 'shared/api/requests/tiktok'
import { createAsyncAction } from 'shared/lib/redux'

export const loadTikTokMessage = createAsyncAction(`${NAMESPACE}/loadMessage`, async () => {
  const messageData = await tiktokApi.tikTokFollowWelcome.getData()

  return getTikTokFollowWelcomeMessageState(messageData.data.follow_welcome)
})

export const loadTikTokMessageReducer = (
  builder: ActionReducerMapBuilder<TikTokFollowWelcomeState>,
) => {
  builder
    .addCase(loadTikTokMessage.fulfilled, (state, action) => ({
      ...state,
      ...action.payload,
    }))
    // Unblocks the automation part, which does not depend on the message
    .addCase(loadTikTokMessage.rejected, (state) => ({
      ...state,
      isMessageFetched: true,
      isMessageLoadFailed: true,
    }))
}
